export const OrderStatus = {
  pending: {
    status: 'pending',
    color: '#2db7f5',
  },
  confirmed: {
    status: 'confirmed',
    color: '#87d068',
  },
  cancelled: {
    status: 'cancelled',
    color: 'error',
  },
  waiting: {
    status: 'waiting',
    color: '#f50',
  },
};

export const PayStatus = {
  pending: {
    status: 'pending',
    color: 'red',
  },
  paid: {
    status: 'paid',
    color: 'cyan',
  },
  deposited: {
    status: 'deposited',
    color: 'geekblue',
  },
};

export const Roles = {
  super: 'super',
  admin: 'admin',
  staff: 'staff',
  customer: 'customer',
  operator: 'operator',
  agent: 'agent',
};

export const operator_params = [
  // --- GENERAL ---
  'sale_status', // Actif/Désactivé
  'sale_fee', // Commission %
  'sale_currency_main', // Devise
  'sale_currency_display', // Affichage devise
  'sale_currency_decimald', // Décimal

  // --- RESERVATION ---
  'sale_date', // Délai annulation réservation
  'sale_date_upto', // Délai limite réservation
  'sale_date_type', // Temps limite réservation

  // --- REPORT ---
  'sale_edit_enable', // Actif/Désactivé
  'sale_edit_type', // Voyage (Avant/Après)
  'sale_edit_days', // Nombre de jours thay đổi
  'sale_edit_times', // Nombre de changement (số lần)
];

export const rate_history_params = ['action'];

export const sms_params = [
  'sms_gateway',
  'sender_id',
  'user_app',
  'operator_app',
];
export const ticket_params = ['template', 'code_type'];
export const payment_params = ['sender_id', 'sms_payment'];
export const user_app_params = [
  'user_app_listing',
  'user_app_status',
  'user_app_booking',
  'user_app_booking_message',
  'user_selling_start',
  'user_custom_stt',
  'user_custom_stt_to',
];

export const operator_app_params = [
  'op_app_listing',
  'op_app_status',
  'op_app_booking',
  'op_app_booking_message',
  'op_selling_start',
  'op_custom_stt',
  'op_custom_stt_to',
];

export const entity_app_params = [
  {
    name: 'User app',
    label: 'user',
  },
  {
    name: 'Operator app',
    label: 'op',
  },
  {
    name: 'Agent app',
    label: 'agent',
  },
];

export const list_app_params = [
  [
    'user_app_listing',
    'user_app_status',
    'user_app_booking',
    'user_app_booking_message',
    'user_selling_start',
    'user_custom_stt',
    'user_custom_stt_to',
  ],
  [
    'op_app_listing',
    'op_app_status',
    'op_app_booking',
    'op_app_booking_message',
    'op_selling_start',
    'op_custom_stt',
    'op_custom_stt_to',
  ],
  [
    'op_app_listing',
    'op_app_status',
    'op_app_booking',
    'op_app_booking_message',
    'op_selling_start',
    'op_custom_stt',
    'op_custom_stt_to',
  ],
];

export const socials = {
  facebook: 'facebook',
  twitter: 'twitter',
  tiktok: 'tiktok',
  instagram: 'instagram',
};
export const site_params = [
  'meta_title',
  'meta_description',
  'meta_keywords',
  'before_head',
  'before_body',
  'og_image',
  'ga_id',
];

export const route_markets = [
  { label: 'Application Utilisateur', value: 'yobuma' },
  { label: 'Application Opérateur', value: 'operator' },
  { label: 'Application Caissier', value: 'agent' },
];

export const post_params = ['meta_description', 'meta_keywords', 'schema_type'];
export const tour_params = ['schema_type', 'meta_description', 'meta_keywords'];

export const field_payment_method = [
  'notify_url',
  'identifiant',
  'site',
  'secret_key',
  'error_url',
  'success_url',
  'merchant_account',
  'client_id',
  'client_secret',
  'code',
  'callback_url',
];

export const menu_params = [
  'image',
  'title',
  'sub_title',
  'meta_title',
  'meta_description',
  'meta_keywords',
];

export const BillType = {
  COLLECT: 'collect',
  PAYMENT: 'payment',
};

export const PaymentTypes = {
  deposited: {
    status: 'deposited',
    color: 'geekblue',
  },
  full: {
    status: 'full',
    color: 'cyan',
  },
};

export const BillStatus = {
  pending: {
    status: 'pending',
    color: '#2db7f5',
  },
  approved: {
    status: 'approved',
    color: '#87d068',
  },
};

export const BillTypes = {
  income: {
    status: 'income',
    color: 'geekblue',
  },
  expense: {
    status: 'expense',
    color: 'cyan',
  },
};

export const TransactionTypes = {
  debit: {
    status: 'debit',
    color: 'geekblue',
  },
  pay: {
    status: 'pay',
    color: 'cyan',
  },
};

export const VoucherStatus = {
  not_send: {
    status: 'not_send',
    color: '#2db7f5',
  },
  sent: {
    status: 'sent',
    color: '#87d068',
  },
};

export const CabinPriceTypes = {
  cabin: 'cabin',
  seat: 'seat',
};

export const payment_method = [
  'orangemoney',
  'freemoney',
  'wave',
  'agent',
  'kpay',
  'cash',
];

export const LocalStorageKeys = {
  order_list: 'order_list',
  booking_statistics: 'booking_statistics',
  booking_seats: 'booking_seats',
};

export const dataSchema_type = [
  'TouristDestination',
  'TouristAttraction',
  'LandmarksOrHistoricalBuildings',
  'TouristTrip',
  'Review',
  'FAQPage',
  'Hotel',
  'HotelRoom',
  'TrainTrip',
];

export const image_fallback =
  'data:image/png;base64,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';

export const AccountType = {
  debt: '131',
  revenue: '511',
  cash: '111',
};

export const ActionTypes = {
  create_booking: 'Create booking',
  amend_booking: 'Amend booking',
  payment_income: 'Payment',
  payment_expense: 'Refund',
  penalty: 'Penalty',
  cancel_return_trip: 'Cancel return trip',
  cancel_booking: 'Cancel booking',
  approve_payment_income: 'Approve payment',
  approve_payment_expense: 'Approve refund',
  refund_recording: 'Refund recording',
};

export const meetingPointType = {
  PICKUP_OFFER: '1',
  MEETING_POINT: '2',
  BOTH: '3',
};

export const priceType = {
  return: 'return',
  flat: 'flat',
};

export const SupplierStatus = {
  pending: {
    status: 'pending',
    color: '#2db7f5',
  },
  confirmed: {
    status: 'confirmed',
    color: '#87d068',
  },
  cancelled: {
    status: 'cancelled',
    color: 'error',
  },
};

export const TourTypes = {
  Tour: 'tour',
  Activity: 'activity',
  Ticket: 'ticket',
  Transport: 'transport',
};

export const OptionUnits = {
  CABIN: 'cabin',
  VEHILCE: 'vehicle',
  ROOM: 'room',
  SEAT: 'seat',
  BED: 'bed',
  PERSON: 'person',
};

export const ReviewStatus = {
  pending: {
    status: 'pending',
    color: '#2db7f5',
  },
  approved: {
    status: 'approved',
    color: '#87d068',
  },
};

export const VehicleType = {
  TRAIN: 'train',
  FOURSEAT: '4seat',
  SEVENSEAT: '7seat',
  NINESEAT: '9seat',
  SIXTEENSEAT: '16seat',
  TWENTYNINESEAT: '29seat',
  FERRY: 'ferry',
};

// export const PUSHER_APP_KEY = "1eac913b2043d18601f4";
export const PUSHER_APP_KEY = '9c74126995eed5c7e4cb';

export const rateUsd = {
  vnd: 25, //units of thousands
};

export const LeadStatus = {
  new: {
    status: 'new',
    color: '#2db7f5',
  },
  open: {
    status: 'open',
    color: '#87d068',
  },
  in_progress: {
    status: 'in_progress',
    color: '#4f49f1',
  },
  unqualified: {
    status: 'unqualified',
    color: '#f50',
  },
  attempted_to_contact: {
    status: 'attempted_to_contact',
    color: '#faad14',
  },
  connected: {
    status: 'connected',
    color: '#1a405c',
  },
  bad_timing: {
    status: 'bad_timing',
    color: '#ff4d4f',
  },
};

export const CampaignType = {
  repeat: {
    status: 'repeat',
    color: '#2db7f5',
  },
  once: {
    status: 'once',
    color: '#87d068',
  },
};

export const SegmentMethodBasic = ['is', 'is_not'];

export const SegmentMethodMultiple = [
  'is',
  'is_not',
  'contain',
  'not_contain',
  'start_with',
  'end_with',
];

export const ContactTargetSegment = {
  lead_status: {
    status: 'lead_status',
    color: '#2db7f5',
    method: SegmentMethodBasic,
  },
  owner: {
    status: 'owner',
    color: '#2db7f5',
    method: SegmentMethodMultiple,
  },
  firstname: {
    status: 'firstname',
    color: '#2db7f5',
    method: SegmentMethodMultiple,
  },
  lastname: {
    status: 'lastname',
    color: '#2db7f5',
    method: SegmentMethodMultiple,
  },
};

export const sourceType = {
  EMAIL: 'Email',
  PHONE: 'Phone',
  LANDINGPAGE: 'LandingPage',
  MEETING: 'Meeting',
  WEB: 'Web',
  CHAT: 'Chat',
  OTHER: 'Other',
};
export const CampaignStatus = {
  new: {
    status: 'new',
    color: '#2db7f5',
  },
  running: {
    status: 'running',
    color: 'processing',
  },
  completed: {
    status: 'completed',
    color: 'success',
  },
  stopped: {
    status: 'stopped',
    color: 'error',
  },
};
